import { isDateExact } from '@bridebook/toolbox';
import {
  DATE_FORMAT,
  dateFromExactDate,
  format,
} from '@bridebook/web/lib/time-date-manipulation/time-date-manipulation';
import {
  useGetWeddingWebsiteDateFormat,
  WeddingWebsiteDateFormat,
} from '@bridebook/web/lib/wedding-website/hooks/use-get-wedding-website-date-format';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { useWeddingWebsiteData } from '../../data/data-context';

/**
 * Couple basics shared by the Motif hero, monogram and footer: display names ("Eleanor & James"), initials for the
 * monogram (["E", "J"]) and the formatted wedding date (undefined when not set).
 */
export const useWeddingBasics = () => {
  const { t } = useTranslation('weddingWebsite');
  const { wedding } = useWeddingWebsiteData();

  const missingPartnerName = t('partners.missingNo');
  const [name, partnerName] = wedding.partners;
  const displayNames = [name || missingPartnerName, partnerName || missingPartnerName];
  const names = displayNames.join(' & ');
  const initials = displayNames.map((displayName) => displayName.trim().charAt(0).toUpperCase());

  const dateFormat = useGetWeddingWebsiteDateFormat();
  const formattedDate = useMemo(() => {
    if (!isDateExact(wedding.date)) return undefined;
    return format(
      dateFromExactDate(wedding.date),
      dateFormat === WeddingWebsiteDateFormat.Ordinal
        ? DATE_FORMAT.DATE.CALENDAR.LONGEST
        : DATE_FORMAT.DATE.WITH_DAY,
    );
  }, [wedding.date, dateFormat]);

  return { names, initials, formattedDate };
};
